var scrollTo = {

    data () {

        return {

            mobile: this.$isMobile(),
            errorElements: null,
            errorElementsVisible: null,
            firstError: null

        }

    },

    methods: {

        scrollToError() {

            if(this.mobile) {

                this.errorElements =  null
                this.errorElementsVisible = null
                let e = setTimeout(()=>this.getErrors(),500)
                
            }

        },

        getErrors () {

            this.errorElements = document.getElementsByClassName('error')

            this.errorElementsVisible = Array.prototype.filter.call(this.errorElements, (element) => {

                let v = this.visible(element)

                if(v) {

                    return element

                }

            })
            
            this.firstError = this.errorElementsVisible[0]

            this.scrollIt(this.firstError)

        },

        scrollIt: function(destination, duration = 200, easing = 'linear', callback) {

            const easings = {

                linear(t) {
                    return t
                },
                easeInQuad(t) {
                    return t * t
                },
                easeOutQuad(t) {
                    return t * (2 - t)
                },
                easeInOutQuad(t) {
                    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
                },
                easeInCubic(t) {
                    return t * t * t
                },
                easeOutCubic(t) {
                    return (--t) * t * t + 1
                },
                easeInOutCubic(t) {
                    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
                },
                easeInQuart(t) {
                    return t * t * t * t
                },
                easeOutQuart(t) {
                    return 1 - (--t) * t * t * t
                },
                easeInOutQuart(t) {
                    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t
                },
                easeInQuint(t) {
                    return t * t * t * t * t
                },
                easeOutQuint(t) {
                    return 1 + (--t) * t * t * t * t
                },
                easeInOutQuint(t) {
                    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t
                }

            }
          
            const start = window.pageYOffset
            const startTime = 'now' in window.performance ? performance.now() : new Date().getTime()
          
            const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight)
            const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight
            const destOffest = destination.getBoundingClientRect()
            
            const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop + 200
            const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset)

            if ('requestAnimationFrame' in window === false) {

                window.scroll(0, destinationOffsetToScroll)

                if (callback) {

                    callback()
                }

                return
            }
          
            function scroll() {

                const now = 'now' in window.performance ? performance.now() : new Date().getTime()
                const time = Math.min(1, ((now - startTime) / duration));
                const timeFunction = easings[easing](time)
                window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start))
            
                if (Math.round(window.pageYOffset) === destinationOffsetToScroll) {

                if (callback) {

                    callback()
                }

                return

                }

                requestAnimationFrame(scroll)

            }
          
            scroll()

        },

        visible(elm) {

            if(!elm.offsetHeight && !elm.offsetWidth) { return false }
            if(getComputedStyle(elm).visibility === 'hidden') { return false }
            
            return true

        },

        offset(elem) {

            if(!elem) elem = this;
        
            var x = elem.offsetLeft
            var y = elem.offsetTop
        
            while (elem == elem.offsetParent) {

                x += elem.offsetLeft
                y += elem.offsetTop

            }
        
            return { left: x, top: y }

        }

    }

}

export default scrollTo